import { Chip } from '@mui/material';
import type { TransactionImportConfidenceLevel } from '@inversor-hub/types';

const labels: Record<TransactionImportConfidenceLevel, string> = {
  HIGH: 'Confianza alta',
  MEDIUM: 'Confianza media',
  LOW: 'Confianza baja',
};

const colors: Record<TransactionImportConfidenceLevel, 'success' | 'warning' | 'error'> = {
  HIGH: 'success',
  MEDIUM: 'warning',
  LOW: 'error',
};

interface ConfidenceChipProps {
  confidence: TransactionImportConfidenceLevel;
}

export const ConfidenceChip = ({ confidence }: ConfidenceChipProps) => (
  <Chip label={labels[confidence]} color={colors[confidence]} size="small" variant="outlined" />
);
